import notificationPreferencesResource from "@/shared/resource/notificationPreferences";
import { authorizedAxios,  } from "./authorizedAxios";
import {
    NotificationPreferencesGetResponse,
} from "@/shared/types";

export function getNotificationPreferences () {
    return authorizedAxios.get<NotificationPreferencesGetResponse>(notificationPreferencesResource.getNotificationPreferences());
}
